import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/usermodule'
import paciente from './modules/pacientemodule'
import theme from './modules/theme'
import getters from './getters'

const store = createStore({
  plugins: [createPersistedState()],
  modules: {
    user,
    paciente,
    theme
  },
  getters
})

export default store